import { IBudgetItem } from '../../../createAndEdit/types';
import { parseDiscountPercent } from '../../../createAndEdit/utils/budgetCalculations';

interface IDetailServiceItemsTableMobileProps {
  items: IBudgetItem[];
  serviceSubtotal?: number;
}

const DetailServiceItemsTableMobile = (props: IDetailServiceItemsTableMobileProps) => {
  const formatCurrency = (value: number): string => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value);
  };

  const parseQuantityToNumber = (qty: string | number | undefined): number => {
    if (qty === undefined || qty === null) return 0;
    const qtyStr = String(qty);
    const clean = qtyStr.replace(/[^\d.,]/g, '').replace(',', '.');
    return Number.parseFloat(clean) || 0;
  };

  const visibleItems = (props.items || []).filter((item) => {
    if (item.removed === true) return false;
    const quantity = parseQuantityToNumber(item.quantity);
    return quantity > 0;
  });

  const calculatedSubtotal = () => {
    return visibleItems.reduce((sum, item) => {
      return sum + (parseQuantityToNumber(item.quantity) * item.value * (1 - parseDiscountPercent(item.discount) / 100));
    }, 0);
  };

  return (
    <div className="mb-3 w-full">
      <div className="flex flex-col gap-3">
        {visibleItems.map((item, index) => {
          const isRemoved = item.removed === true;
          const subtotal = parseQuantityToNumber(item.quantity) * item.value * (1 - parseDiscountPercent(item.discount) / 100);
          
          return (
            <div
              key={`item-${item.ref}-${index}`}
              className={`border border-gray-200 rounded-md p-3 ${isRemoved ? 'bg-red-50' : 'bg-white'}`}
            >
              <div className="flex flex-col gap-2">
                <div className="flex flex-row justify-between items-start">
                  <div className="flex-1">
                    <div className="text-size-12 text-gray-600">Ref.</div>
                    <div className="text-size-14 font-semibold">{item.ref}</div>
                  </div>
                  <div className="flex-1">
                    <div className="text-size-12 text-gray-600">Item</div>
                    <div className="text-size-14 font-semibold">{item.item}</div>
                  </div>
                </div>
                <div>
                  <div className="text-size-12 text-gray-600">Descrição</div>
                  <div className="text-size-14">{item.description}</div>
                </div>
                <div className="flex flex-row gap-4">
                  <div className="flex-1">
                    <div className="text-size-12 text-gray-600">Quantidade</div>
                    <div className="text-size-14 text-right">{item.quantity}</div>
                  </div>
                  <div className="flex-1">
                    <div className="text-size-12 text-gray-600">Valor (R$)</div>
                    <div className="text-size-14 text-right">{formatCurrency(item.value)}</div>
                  </div>
                  <div className="flex-1">
                    <div className="text-size-12 text-gray-600">% Desconto</div>
                    <div className="text-size-14 text-right">{item.discount}</div>
                  </div>
                  <div className="flex-1">
                    <div className="text-size-12 text-gray-600">Subtotal (R$)</div>
                    <div className="text-size-14 font-bold text-right">{formatCurrency(subtotal)}</div>
                  </div>
                </div>
                {isRemoved && (
                  <div className="text-red-400 text-size-12 font-bold mt-2">
                    Removido pelo Volks|total
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
      {typeof props.serviceSubtotal === 'number' && (
        <div className="mt-4 text-right pr-2">
          <span className="text-gray-600 mr-2 text-size-14">Subtotal do serviço:</span>
          <span className="font-bold text-size-16">{formatCurrency(calculatedSubtotal())}</span>
        </div>
      )}
    </div>
  );
};

export default DetailServiceItemsTableMobile;
